import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/preparer/users')({
  component: UsersLayout,
});

function UsersLayout() {
  return <Outlet />;
}
